import React from 'react';
import { ArrowRight } from 'lucide-react';

interface MoonshotSectionProps {
  onSignUp: () => void;
}

export function MoonshotSection({ onSignUp }: MoonshotSectionProps) {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 mb-20">
      <div className="relative">
        {/* Background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-transparent rounded-3xl blur-3xl" />

        {/* Content */}
        <div className="relative text-center">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6 font-['Sora']">
            So, What's Your Next Moonshot?
          </h2>

          <p className="text-xl text-gray-300 max-w-2xl mx-auto mb-12">
            The distance between dreams and reality is called action.
          </p>

          <button
            onClick={onSignUp}
            className="group relative inline-flex items-center gap-3 bg-blue-500 text-white px-8 py-4 rounded-lg text-lg font-medium overflow-hidden"
          >
            {/* Shine effect */}
            <div
              className="absolute inset-0 w-[20%] bg-gradient-to-r from-transparent via-white/30 to-transparent opacity-0 group-hover:opacity-100 group-hover:animate-[button-shine_0.8s_ease-in-out]"
              style={{ transform: 'skewX(-15deg)' }}
            />

            {/* Scale effect */}
            <div className="relative z-10 transition-transform duration-200 group-hover:scale-105">
              <span>Start Your Journey</span>
              <ArrowRight
                size={24}
                className="inline-block ml-2 transition-transform duration-200 group-hover:translate-x-1"
              />
            </div>

            {/* Glow effect */}
            <div className="absolute inset-0 rounded-lg transition-all duration-300 group-hover:shadow-[0_0_25px_rgba(59,91,219,0.5)]" />
          </button>
        </div>
      </div>
    </div>
  );
}
